"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TriangleDown = void 0;
var react_1 = __importDefault(require("react"));
var TriangleDown = function (_a) {
  var className = _a.className;
  return react_1.default.createElement("svg", {
    className: className,
    width: "16",
    height: "12",
    viewBox: "0 0 16 12"
  }, react_1.default.createElement("path", {
    d: "M8.9548 9.00939L13.7028 4.2614C13.9703 3.99391 14.104 3.59267 13.9034 3.19144C13.7697 2.7902 13.3684 2.52271 12.9672 2.52271L3.0031 2.5227C2.60186 2.5227 2.20062 2.7902 2.06687 3.19144C2 3.32518 2 3.45893 2 3.59267C2 3.86017 2.13375 4.12766 2.33437 4.32828L7.08235 9.07627C7.34985 9.34376 7.68421 9.4775 8.08545 9.4775C8.48669 9.4775 8.68731 9.27688 8.9548 9.00939Z"
  }));
};
exports.TriangleDown = TriangleDown;